module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-xl-7 col-lg-8 col-md-10 col-sm-12"
  }, [_c('table', {
    staticClass: "table table-sm table-summary"
  }, [_c('tbody', [_vm._m(0, false, false), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Now")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.now, false)) + "\n              ("), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.price_change(coin))
      }
    }), _vm._v(")\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.4f', _vm.sum('BCH').price.now / _vm.sum('BTC').price.now)) + "\n              ("), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.price_ratio(false))
    }
  }), _vm._v(")\n            ")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              -1d\n            ")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.day_1, false)) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.4f', _vm.sum('BCH').price.day_1 / _vm.sum('BTC').price.day_1)) + "\n            ")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              -7d\n            ")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.day_7, false)) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.4f', _vm.sum('BCH').price.day_7 / _vm.sum('BTC').price.day_7)) + "\n            ")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              -30d\n            ")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.day_30, false)) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.4f', _vm.sum('BCH').price.day_30 / _vm.sum('BTC').price.day_30)) + "\n            ")])], 2)])])])])]), _vm._v(" "), _c('rdari'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-xl-7 col-lg-8 col-md-10"
  }, [_c('table', {
    staticClass: "table table-sm table-summary"
  }, [_c('tbody', [_vm._m(1, false, false), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('dari')
      }
    }
  }, [(_vm.showstats.dari) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.dari) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                DARI ratio\n                "), _c('small', [_vm._v("(period averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'reward.dari'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.dari) ? [_c('tr', [_c('td', [_vm._v("Now*")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('strong', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'blk_3'))
      }
    })])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 hour")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'hour_6'))
      }
    })])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'day_1'))
      }
    })])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'day_7'))
      }
    })])
  })], 2), _vm._v(" "), _vm._m(2, false, false)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('hashrate')
      }
    }
  }, [(_vm.showstats.hashrate) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.hashrate) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Relative hashrate\n                "), _c('small', [_vm._v("(period averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'pow.hashrate'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.hashrate) ? [_c('tr', [_c('td', [_vm._v("6 hours")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'hour_6')) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'day_1')) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'day_7')) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("30 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'day_30')) + "\n              ")])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('blockrate')
      }
    }
  }, [(_vm.showstats.blockrate) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.blockrate) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Blocks found\n                "), _c('small', [_vm._v("(period sum/rate)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'blocks.time'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.blockrate) ? [_c('tr', [_c('td', [_vm._v("Last hour")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sum(coin).blocks.hour_1) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 hours")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.0f', _vm.sum(coin).blocks.hour_6)) + " (" + _vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocks.per_hour.hour_6)) + "/hr)\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("24 hours")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.0f', _vm.sum(coin).blocks.day_1)) + " (" + _vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocks.per_hour.day_1)) + "/hr)\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 weeks")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.0f', _vm.sum(coin).blocks.day_14)) + " (" + _vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocks.per_hour.day_14)) + "/hr)\n              ")])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('txs')
      }
    }
  }, [(_vm.showstats.txs) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.txs) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Confirmed transactions\n                "), _c('small', [_vm._v("(24h averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'tx.txs'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.txs) ? [_c('tr', [_c('td', [_vm._v("Per block")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).txs.block)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Per second")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).txs.second)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Per hour")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).txs.hour)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Per day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).txs.day)))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('txfee')
      }
    }
  }, [(_vm.showstats.txfee) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.txfee) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Transaction fees\n                "), _c('small', [_vm._v("(24h averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'tx.fee'
      }
    }
  })], 1)]), _vm._v(" "), (_vm.showstats.txfee) ? [_c('tr', [_c('td', [_vm._v("Sat/B")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).tx_fees.sat_b)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("USD/kB")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.money(_vm.sum(coin).tx_fees.usd_kb)))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('reward')
      }
    }
  }, [(_vm.showstats.reward) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.reward) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n            Average block reward\n          ")]), _vm._v(" "), _c('small', [_vm._v("\n                ("), _c('span', {
    class: {
      'rpa': _vm.rewardperiod == 'block'
    },
    on: {
      "click": function($event) {
        _vm.rewardperiod = 'block'
      }
    }
  }, [_vm._v("last block")]), _vm._v(",\n                "), _c('span', {
    class: {
      'rpa': _vm.rewardperiod == 'day'
    },
    on: {
      "click": function($event) {
        _vm.rewardperiod = 'day'
      }
    }
  }, [_vm._v("past day")]), _vm._v(",\n                "), _c('span', {
    class: {
      'rpa': _vm.rewardperiod == 'week'
    },
    on: {
      "click": function($event) {
        _vm.rewardperiod = 'week'
      }
    }
  }, [_vm._v("past week")]), _vm._v(")\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'reward.blocks'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.reward) ? [_c('tr', [_c('td', [_vm._v("Coinbase")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.money(_vm.rp(coin).coinbase / _vm.rpb(coin), false)) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fees")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.money(_vm.rp(coin).fees / _vm.rpb(coin), false)) + "\n                "), _c('small', [_vm._v("(" + _vm._s(_vm.sprintf('%.2f', _vm.rp(coin).fees_coin / _vm.rpb(coin))) + " " + _vm._s(coin) + ")")])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.money(_vm.rp(coin).total / _vm.rpb(coin), false)) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fee %")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.2f%%', (_vm.rp(coin).fee_pct))) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DARI")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rewardperiod === 'block'),
        expression: "rewardperiod === 'block'"
      }]
    }, [_vm._v(_vm._s(_vm.sprintf('%.2f', (_vm.sum(coin).dari.last))))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rewardperiod === 'day'),
        expression: "rewardperiod === 'day'"
      }]
    }, [_vm._v(_vm._s(_vm.sprintf('%.2f', (_vm.sum(coin).dari.day_1))))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rewardperiod === 'week'),
        expression: "rewardperiod === 'week'"
      }]
    }, [_vm._v(_vm._s(_vm.sprintf('%.2f', (_vm.sum(coin).dari.day_7))))])])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('blocksize')
      }
    }
  }, [(_vm.showstats.blocksize) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.blocksize) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Average blocksize in kB\n                "), _c('small', [_vm._v("(excluding empty blocks)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'blocks.size'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.blocksize) ? [_c('tr', [_c('td', [_vm._v("Today")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocksize.day_1)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-7 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocksize.day_7)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-30 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocksize.day_30)))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('retarget')
      }
    }
  }, [(_vm.showstats.retarget) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.retarget) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Difficulty retarget\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'pow.retarget'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.retarget) ? [_c('tr', [_c('td', [_vm._v("Date (24h UTC)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date('BTC')))]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Remaining")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.days('BTC')) + "\n                "), _c('small', [_vm._v("(" + _vm._s(_vm.left('BTC')) + " blk)")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Change")]), _vm._v(" "), _c('td', [(_vm.next_pct('BTC', true) > 1) ? _c('i', {
    staticClass: "fa fa-chevron-up green"
  }) : _vm._e(), _vm._v(" "), (_vm.next_pct('BTC', true) < 1) ? _c('i', {
    staticClass: "fa fa-chevron-down red"
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.next('BTC')) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("-")])])] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('halvening')
      }
    }
  }, [(_vm.showstats.halvening) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.halvening) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Halvening\n                "), _c('small', [_vm._v("(based on blocks past 30 days)")])])])]), _vm._v(" "), (_vm.showstats.halvening) ? [_c('tr', [_c('td', [_vm._v("Blocks")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sum(coin).halvening.blocks))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Days")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).halvening.seconds / (24 * 3600))))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("New reward*")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.halvening_reward(coin)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("New fee %**")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.halvening_fees(coin)))])
  })], 2), _vm._v(" "), _vm._m(3, false, false)] : _vm._e()], 2)])])])]), _vm._v(" "), _c('small', [(_vm.showstats.halvening) ? [_c('feemarket')] : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "noboto"
  }), _vm._v(" "), _c('td', {
    staticClass: "noboto"
  }, [_vm._v("BTC/USD")]), _vm._v(" "), _c('td', {
    staticClass: "noboto"
  }, [_vm._v("BCH/USD")]), _vm._v(" "), _c('td', {
    staticClass: "noboto"
  }, [_vm._v("BCH/BTC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "noboto"
  }), _vm._v(" "), _c('td', {
    staticClass: "noboto",
    attrs: {
      "align": "center"
    }
  }, [_c('strong', [_vm._v("BTC")])]), _vm._v(" "), _c('td', {
    staticClass: "noboto",
    attrs: {
      "align": "center"
    }
  }, [_c('strong', [_vm._v("BCH")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('small', [_vm._v("\n                  * The average of the last 3 blocks is used to even out tx fees.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('small', [_vm._v("\n                  * Based on 30d average coinbase+fees with current exchange rate ** Income from fees as a percentage of the total block reward\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7ac12f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary.vue
// module id = 559
// module chunks = 1